import { Component, Inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { connectFunctionsEmulator, Functions } from '@angular/fire/functions';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { environment } from 'src/environments/environment';
import { UserService } from './services/user.service';
import { PurchaseService } from './services/purchase.service';
import { Platform } from '@ionic/angular';

import { Router } from '@angular/router';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  constructor(
    private userService: UserService,
    private purchaseService: PurchaseService,
    @Inject('FIREBASE_FUNCTIONS') private functions: Functions,
    @Inject('FIREBASE_AUTH') private auth: Auth,
    private platform: Platform,
    private router: Router,
    private analyticsService: AnalyticsService
  ) {}

  public async ngOnInit(): Promise<void> {
    this.platform.ready().then(() => {
      if (environment.emulator) {
        connectFunctionsEmulator(this.functions, 'localhost', 5001);
      }
      this.userService.init();
      this.analyticsService.setEnabled(true);

      let purchaseIsInitialized = false;
      authState(this.auth).subscribe(user => {
        const splashLogo = document.querySelector('#splash-logo');
        if (splashLogo) {
          splashLogo.remove();
        }
        if (user) {
          if (!purchaseIsInitialized) {
            purchaseIsInitialized = true;
            this.purchaseService.init();
          }

          this.analyticsService.initUser(user.uid, user.email || '', user.displayName || '');
        }
      });
    });
  }
}
